import { render, staticRenderFns } from "./YearlyRevenueChart.vue?vue&type=template&id=554a3c7f"
import script from "./YearlyRevenueChart.vue?vue&type=script&lang=js"
export * from "./YearlyRevenueChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports